
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import AudioServices from './components/AudioServices';
import About from './components/About';
import Gallery from './components/Gallery';
import Testimonials from './components/Testimonials';
import Awards from './components/Awards';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Services />
      <AudioServices />
      <About />
      <Gallery />
      <Testimonials />
      <Awards />
      <Contact />
      <Footer />
    </div>
  );
}
